import CoverBlock from "./CoverBlock";
import QuoteSlider from "../QuoteSlider";

export default class CoverBlockQuoteSlider extends CoverBlock {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        super(element);

        /**
         * @type {NodeListOf<HTMLElementTagNameMap[string]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[string]>}
         * @private
         */
        this._quotes = this._element.querySelectorAll('blockquote');

        /**
         * @type {null|QuoteSlider}
         * @private
         */
        this._slider = null;

        if (this._quotes.length > 1) {
            this._slider = new QuoteSlider(this._quotes[0].parentElement, this._quotes);
        }
    }

    /**
     * @param {HTMLElement} element
     * @return {boolean}
     */
    static is(element) {
        return element.classList.contains('wp-block-cover') && element.classList.contains('is-style-quote-slider');
    }
}